export const PAPER_OPTIONS = ["Matte Finish", "Gloss Finish"];

export type PaperType = {
  deckle: boolean;
  description: string;
  label: string;
  size: number;
  type: string;
  url: string;
};

export const PAPER_TYPES_MATTE = [
  {
    deckle: true,
    description:
      "Fine art matte cotton paper with a subtle soft surface texture. Versatile and suitable for both photography and artwork reproduction.\n\nBright White I 310 gsm, 100% cotton",
    label: "Hahnemuhle Photo Rag Bright",
    size: 43,
    type: "type1",
    url: "/content/papers/matte/hahnemuhle-photo-rag-bright.jpg",
  },
  {
    // Added 2026-10-01 (Michael): same roll limit and tier as Photo Rag Bright; code PR308.
    deckle: true,
    description:
      "Fine art matte cotton paper with a lightly defined felt texture and a wonderfully soft feel. Deep blacks, brilliant colours and fine detail; the classic all-rounder for photography and art reproduction. The most archival paper in the Hahnemühle lineup, with no optical brighteners.\n\nWhite I 308 gsm I 100% cotton",
    label: "Hahnemuhle Photo Rag 308",
    size: 43,
    type: "type1",
    url: "/content/papers/matte/hahnemuhle-photo-rag-308.jpg",
  },
  {
    deckle: true,
    description:
      "Traditional mould-made etching paper with a unique, velvety surface texture. Perfect for fine art reproduction and photography.\n\nWhite I 310 gsm I 100% alpha cellulose",
    label: "Hahnemuhle German Etching",
    size: 43,
    type: "type1",
    url: "/content/papers/matte/hahnemuhle-german-etching.jpg",
  },
  {
    deckle: true,
    description:
      "100% cotton paper with an ultra-smooth surface texture – guarantees archival standards. Photo Rag® Ultra Smooth meets the highest industry standards regarding density, colour gamut, colour graduation and image sharpness while preserving the special touch and feel of genuine art paper. Available in all sizes. White I 305 gsm, 100% cotton",
    label: "Hahnemuhle Photo Rag Ultra Smooth",
    size: 62,
    type: "type1",
    url: "/content/papers/matte/hahnemuehle_photo_rag_ultra_smooth.jpg",
  },
  {
    deckle: true,
    description:
      "Smooth, lightly textured bright matte finish with high color gamut and black density. Available in 60'' rolls for extra large prints! Bright White I 330 gsm I 100% cotton",
    label: "Epson Hot Press Bright",
    size: 58,
    type: "type1",
    url: "/content/papers/matte/hot-press-bright.jpg",
  },
  {
    deckle: true,
    description:
      "Elegantly textured bright white finish with an extremely-high color gamut and black density. Avaiable in 60''\n\nBright White I 340 gsm I 100% cotton",
    label: "Epson Cold Press Bright",
    size: 58,
    type: "type1",
    url: "/content/papers/matte/cold-press-bright.jpg",
  },
  {
    deckle: true,
    description:
      "Economical option with a flat matte bright cool white surface. yields highly saturated images with excellent highlight and shadow detail.\n\nBright White I 192 gsm",
    label: "Epson Enhanced Matte",
    size: 43,
    type: "type2",
    url: "/content/papers/matte/enhanced-matte.jpg",
  },
];

export const PAPER_TYPES_GLOSS = [
  {
    deckle: false,
    description:
      "Delicately textured with a smooth, silky feel, producing a subtle, pearl-gloss effect. Ideal for printing high-quality black and white as well as color photographs.\n\nBright white I 285 gsm I 100% alpha-cellulose",
    label: "Hahnemuhle Fine Art Pearl",
    size: 43,
    type: "type1",
    url: "/content/papers/gloss/hahnemuhle-fine-art-pearl.jpg",
  },
  {
    deckle: false,
    description:
      "Pure cotton paper with a glossy inkjet coating that gives the paper a delicate feel and exquisite texture. Warm white tone produces an elegant sheen without glare.\n\nWarm White I 315 gsm I 100% cotton base",
    label: "Hahnemuhle Photo Rag Baryta",
    size: 62,
    type: "type1",
    url: "/content/papers/gloss/hahnemuhle-photo-rag-baryita.jpg",
  },
  {
    deckle: false,
    description:
      "Silvery-shimmering textured paper with a high-gloss premium inkjet coating for a unique metallic effect with high-contrast tones shine.\n\nNatural White I 340 gsm I 100% cotton",
    label: "Hahnemuhle Photo Rag Metallic",
    size: 48,
    type: "type1",
    url: "/content/papers/gloss/hahnemuhle-photo-rag-metallic.jpg",
  },
  {
    deckle: false,
    description:
      "Smooth, high-gloss, photographic paper features a unique metallic surface that provides extreme sharpness and depth.\n\nBright White I 257 gsm I Resin-coated base",
    label: "Epson Glossy Metallic",
    size: 43,
    type: "type1",
    url: "/content/papers/gloss/glossy-metallic-photo-paper.jpg",
  },
  {
    deckle: false,
    description:
      "Classic photo inkjet paper with a smooth luster finish. Excellent print quality suitable for photos and poster prints.\n\nBright White I 260 gsm I Resin-coated base",
    label: "Premium Luster Photo Paper",
    size: 58,
    type: "type2",
    url: "/content/papers/gloss/luster-photo-paper.jpg",
  },
  {
    deckle: false,
    description:
      "Classic photo paper with a smooth, high-gloss surface finish. Highly detailed print quality excellent D-max - Bright White I 260 gsm I Resin-coated base",
    label: "Premium Glossy Photo Paper",
    size: 43,
    type: "type2",
    url: "/content/papers/gloss/glossy-photo-paper.jpg",
  },
];

export const CANVAS_MATTE = [
  {
    label: "Exhibition Matte Canvas",
    description:
      "Features an acid free, lignin-free heavyweight cotton-poly blend, with a matte non-reflective surface, making it suitable for gallery and museum-quality prints. Yields deep blacks and a wide color spectrum. Ideal for gallery wrap stretching. 395 g/m2 media weight and a 23.0 mil thickness.",
    size: 57,
    url: "/content/canvas/matte-canvas.webp",
  },
];

export const CANVAS_GLOSS = [
  {
    label: "Metallic Canvas",
    description:
      "Is a bright white fine art canvas, created from an optimal blend of metallic, silver, and pearlescent surface finishes. High-gloss premium inkjet coating for outstanding printing results with a unique, silvery-shimmering metallic effect",
    size: 53,
    url: "/content/canvas/metallic-canvas.webp",
  },
];
